import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Equipment } from '../../shared/interfaces/equipment.interfaces';

@Injectable({
  providedIn: 'root'
})

export class FrontEquipmentService {

  // Model interpretation from serial number
  interpretEquipment(equipment: Equipment): Observable<Equipment> {
    let model = '';
    // Check for 12 hexadecimal digits
    if (equipment.sn && /^[0-9A-Fa-f]{12}$/.test(equipment.sn)) {
      model = 'SmartAlarm';
    } else {
      let extractedSn3 = equipment.sn ? equipment.sn.slice(0, 3) : '';
      let extractedSn4 = equipment.sn ? equipment.sn.slice(0, 4) : '';
      switch (extractedSn3) {
        case '179':
          model = 'NT-COM 4 / IPCOM';
          break;
        case '253':
          model = 'NT-A2K8/4NG 3G';
          break;
        case '254':
          model = 'NT-A2K8/4NG 4G';
          break;
        case '256':
          model = 'NT-A2K8/4NG 4G/5G';
          break;
        case '259':
          model = 'NT-A2K8/4NG WiFi';
          break;
        case '277':
          model = 'NT-Link G';
          break;
        case '347':
          model = 'NT-Link 3G (Q)';
          break;
        case '374':
          model = 'NT-Link 3G (S)';
          break;
        case '599':
          model = 'NT-COM';
          break;
        case '674':
          model = 'Optimus 4G/WiFi';
          break;
        case '679':
          model = 'Optimus WiFi';
          break;
        case '699':
          model = 'NT-COM';
          break;
        case '703':
          model = 'NT-Link G';
          break;
        case '707':
          switch (extractedSn4) {
            case '7071':
            case '7072':
            case '7074':
              model = 'NT-Link 3G (S)';
              break;
            case '7073':
              model = 'NT-Link 2G (S)';
              break;
          }
          break;
        case '709':
          model = 'NT-COM 3G (S)';
          break;
        case '713':
          model = 'NT-Link WiFi';
          break;
        case '714':
          model = 'NT-Link 4G/5G';
          break;
        case '715':
          model = 'NT-COM 3G (Q)';
          break;
        case '716':
          model = 'NT-ACM 4G';
          break;
        case '717':
          model = 'Optimus Prototype';
          break;
        case '778':
          model = 'PST';
          break;
        case '844':
          model = 'NT-Com 4G';
          break;
        case '915':
          model = 'NT-Link 4G';
          break;
        default:
          model = '';
      }
    }

    // Panel interpretation from firmware
    let panel = '';
    if (equipment.panel) {
      // console.log(equipment.sn + equipment.panel);
      switch (equipment.panel) {
        case 'NO_KEYBUS':
          panel = 'No bus';
          break;
        case 'DSC':
          panel = 'DSC';
          break;
        case 'PARADOX':
          panel = 'Paradox';
          break;
        case 'HONEYWELL':
        case 'HONNEYWELL':
          panel = 'Honeywell';
          break;
        case 'GARNET':
          panel = 'Garnet';
          break;
        default:
          panel = equipment.panel;
      }
    } else if (equipment.firmware) {
      // Format Vetti: 6.66, 6.67
      if (/^\d\.\d{2}$/.test(equipment.firmware)) {
        panel = 'Vetti';
      } else {
        // Format Netio TCP: ntlinkg01E001-8.5.0, sandbox02A001-7.1.5
        const regexFormat1 = /^(\w+)(\d{2})([A-Z\d])\d{3}-/i;
        const match1 = equipment.firmware.match(regexFormat1);
        if (match1) {
          const panelCode = match1[2];
          switch (panelCode) {
            case '00':
              panel = 'Universal';
              break;
            case '01':
              panel = 'DSC';
              break;
            case '02':
              panel = 'Paradox';
              break;
            case '03':
              panel = 'Honeywell';
              break;
            case '04':
              panel = 'Garnet';
              break;
            case '99':
              panel = 'Test';
              break;
            default:
              panel = '';
          }
        } else {
          // Format Netio UDP: linkdsc-5.1.0, linkpdx-3.0.5, linka2k8-6.2.0, ntcom-4.4.16
          const fw = equipment.firmware.toLowerCase();
          if (fw.includes('dsc')) {
            panel = 'DSC';
          } else if (fw.includes('pdx')) {
            panel = 'Paradox';
          } else if (fw.includes('a2k')) {
            panel = 'Garnet';
          } else if (fw.includes('ntcom') || fw.includes('ntfull') || fw.includes('ipcom') || fw.includes('ntmod3g')) {
            panel = 'Universal';
          } else {
            panel = '';
          }
        }
      }
    } else {
      panel = '';
    }

    // IMSI interpretation
    let simcard = equipment.simcard;
    if (simcard && simcard.imsi) {
      let mccmnc = simcard.imsi.slice(0, 5);
      let provider = '';
      let apn = '';
      let user = '';
      let password = '';

      switch (mccmnc) {
        // --- Argentina ---
        case '72207': // Movistar Argentina
          apn = "m2m.movistar";
          user = "movistar";
          password = "movistar";
          provider = 'Movistar';
          break;
        case '72231': // Claro Argentina
          apn = "igprs.claro.com.ar";
          user = "clarogprs";
          password = "clarogprs999";
          provider = 'Claro';
          break;
        case '72234': // Personal Argentina
          apn = "gprs.personal.com";
          user = "gprs";
          password = "adgj";
          provider = 'Personal';
          break;
        case '72236': // Personal Jasper Argentina
          apn = "m2m.personal.com";
          user = "";
          password = "";
          provider = 'Personal Jasper';
          break;

        // --- Bolivia ---
        case '73601': // Viva Bolivia
          apn = "3g.nuevatel.com";
          user = "";
          password = "";
          provider = 'Viva';
          break;
        case '73602': // Entel Bolivia
          apn = "4g.entel";
          user = "";
          password = "";
          provider = 'Entel';
          break;
        case '73603': // Tigo Bolivia
          apn = "internet.tigo.bo";
          user = "";
          password = "";
          provider = 'Tigo';
          break;

        // --- Chile ---
        case '73001': // Entel Chile
          apn = "bam.entelpcs.cl";
          user = "entelpcs";
          password = "entelpcs";
          provider = 'Entel';
          break;
        case '73002': // Movistar Chile
          apn = "wap.tmovil.cl";
          user = "wap";
          password = "wap";
          provider = 'Movistar';
          break;
        case '73003': // Claro Chile
          apn = "bam.clarochile.cl";
          user = "clarochile";
          password = "clarochile";
          provider = 'Claro';
          break;

        // --- Colombia ---
        case '73210': // Movistar Colombia
          apn = "internet.movistar.com.co";
          user = "movistar";
          password = "movistar";
          provider = 'Movistar';
          break;
        case '73211': // Tigo Colombia
          apn = "web.colombiamovil.com.co";
          user = "";
          password = "";
          provider = 'Tigo';
          break;
        case '73212': // Virgin Mobile Colombia
          apn = "web.vmc.net.co";
          user = "";
          password = "";
          provider = 'Virgin';
          break;

        // --- Mexico ---
        case '33402': // Telcel Mexico
          apn = "internet.itelcel.com";
          user = "webgprs";
          password = "webgprs2002";
          provider = 'Telcel';
          break;
        case '33403': // Movistar Mexico
          apn = "internet.movistar.mx";
          user = "";
          password = "";
          provider = 'Movistar';
          break;
        case '33409': // AT&T Mexico
          apn = "modem.nexteldata.com.mx";
          user = "";
          password = "";
          provider = 'AT&T';
          break;

        // --- Paraguay ---
        case '74402': // Claro Paraguay
          apn = "internet.ctimovil.com.py";
          user = "ctigprs";
          password = "ctigprs999";
          provider = 'Claro';
          break;
        case '74404': // Tigo Paraguay
          apn = "internet.tigo.py";
          user = "tigo";
          password = "tigo";
          provider = 'Tigo';
          break;
        case '74405': // Personal Paraguay
          apn = "internet";
          user = "personal";
          password = "personal";
          provider = 'Personal';
          break;

        // --- Uruguay ---
        case '74800': // Ancel Uruguay
        case '74801': // Ancel Uruguay
        case '74803': // Ancel Uruguay
          apn = "antel.lte";
          user = "gprs";
          password = "gprs";
          provider = 'Ancel';
          break;
        case '74807': // Movistar Uruguay
          apn = "webapn.movistar.com.uy";
          user = "movistar";
          password = "movistar";
          provider = 'Movistar';
          break;
        case '74810': // Claro Uruguay
          apn = "internet.ctimovil.com.uy";
          user = "ctigprs";
          password = "ctigprs999";
          provider = 'Claro';
          break;

        // --- Multicarriers ---
        case '20404': // Vodafone
          apn = "vf.m2mdataglobal.com";
          user = "vf";
          password = "vf";
          provider = 'Vodafone';
          break;
        case '21407': // Movistar
          apn = "internet.movistar.com.co";
          user = "";
          password = "";
          provider = 'Movistar';
          break;
        case '23410': // Moabits altanwifi
          apn = "altanwifi";
          user = "";
          password = "";
          provider = 'Moabits';
          break;
        case '29505': // Eminfy
          apn = "em";
          user = "";
          password = "";
          provider = 'Eminfy';
          break;
        case '45400': // Moabits tn1
        case '52505': // Moabits tn1
          apn = "tn1";
          user = "";
          password = "";
          provider = 'Moabits';
          break;

        default:
          provider = '';
      }

      if (provider) {
        simcard = { ...simcard, provider };
      }
      if (apn) {
        simcard = { ...simcard, apn };
      }
      if (user) {
        simcard = { ...simcard, user };
      }
      if (password) {
        simcard = { ...simcard, password };
      }
    }

    return of({
      ...equipment,
      simcard,
      model,
      panel
    });
  }

}
